var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeArrowQuestionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.20707,
    cy: 8.92777,
    r: 8.335,
    fill: "#17A7E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_9567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64067 5.93131C8.7794 5.77565 8.98749 5.67188 9.19559 5.67188C9.40369 5.67188 9.61179 5.77565 9.75052 5.93131L13.9818 10.6789C14.2824 11.0162 14.2824 11.587 13.9818 11.9242C13.6812 12.2615 13.1726 12.2615 12.872 11.9242L9.19559 7.82518L5.54232 11.9242C5.38047 12.1058 5.19549 12.1837 4.9874 12.1837C4.7793 12.1837 4.5712 12.1058 4.43247 11.9242C4.13188 11.587 4.13188 11.0162 4.43247 10.6789L8.64067 5.93131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_9567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0002,
    height: 11.5119,
    fill: "white",
    transform: "translate(14.207 14.6836) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeArrowQuestionsIcon);
export default __webpack_public_path__ + "static/media/take-arrow-questions-icon.581155e967c761c267c2d1ff738e4443.svg";
export { ForwardRef as ReactComponent };